/// <amd-module name="Core/Medius.Core.Web/Scripts/components/sendEmailDialog/utils"/>
import { getRegex } from "Core/Medius.Core.Web/Scripts/Medius/core/validation/email";
import { Contact } from "./types";

export const validateEmails = (values: Contact[]): boolean => {
    const emailRegex = getRegex();
    return values.every(value => emailRegex.test(value.emailAddress));
};

export const validateEmail = (value: string): boolean => {
    const emailRegex = getRegex();
    return emailRegex.test(value);
};

export const isNullOrEmpty = (array: any[]) => {
    return !array || array.length === 0;
};
